import { useState } from "react";
import { AppLayout } from "../../../layout/AppLayout";
import { AnimatePresence, motion } from "framer-motion";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { useNavigate } from "react-router-dom";
import {
  CheckedCircle,
  CircledCheveron,
} from "../../../components/svg/GeneralIcons";
import { Loader } from "../../../components/loader/Loader";
import { FullModal } from "../../world/rmc/modals/fullModal";
import Button from "../../../components/button/Button";

export const Swap = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-svh flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Swap</p>
          </div>

          <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
            <div className="flex-grow flex items-center flex-col w-full">
              <img
                className="w-24 h-24"
                src="/image/convert_points.png"
                alt="points_convert_image"
                loading="lazy"
              />
              <div className="my-9 text-center">
                <div className="mb-2 ">
                  <p className="text-black text-3xl font-semibold">₦30,000</p>
                  <p className="text-base text-black font-semibold">
                    Available Cash
                  </p>
                </div>
                <div className=" text-[#00000080] ">
                  <p className="text-sm font-normal">
                    Convert your cash to points
                  </p>
                  <p className=" text-sm font-semibold">₦10 = 4 points </p>
                </div>
              </div>
              <div className="w-full">
                <p className="text-xs text-[#00000080] font-medium">
                  ENTER AMOUNT
                </p>
                <div className="my-1 border border-[#0000004D] bg-white rounded-md px-3.5 pb-4 pt-3.5 flex justify-between items-center">
                  <div>
                    <span className="text-[#00000080] text-sm font-medium">
                      Points
                    </span>
                    <p className="text-lg font-semibold text-black">15,000</p>
                  </div>
                  <CircledCheveron />

                  <div>
                    <span className="text-[#00000080] text-sm font-medium">
                      You’ll get
                    </span>
                    <p className="text-lg font-semibold text-black">₦30,000</p>
                  </div>
                </div>
                <p className="text-[#2741D6CC] text-xs font-medium">
                  You need minimum of ₦500 cash to swap
                </p>
              </div>
            </div>
            <div className="mt-4 w-full">
              <Button
                onClick={() => setShow(true)}
                text={"" ? <Loader type="bubbles" /> : "Swap Now"}
                // className={isLoading && "!py-0"}
                className="!py-4 !mt-7 !rounded-[50px]"
              />
            </div>
          </div>
        </motion.div>
      </div>
      <AnimatePresence>
        {show && (
          <FullModal className="fixed h-full inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto ">
            <div className="pt-10 pb-7 px-5 min-h-svh flex flex-col">
              <div className="w-full relative flex flex-col flex-grow">
                <div className="relative flex items-center justify-center mb-0"></div>

                <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
                  <div className="flex-grow flex items-center flex-col w-full ">
                    <CheckedCircle />
                    <div className="my-12 mb-7 text-center">
                      <p className="text-black text-3xl font-semibold">
                        Success!
                      </p>
                      <p className="text-lg text-black font-medium">
                        Points swapped successfully
                      </p>
                    </div>

                    <div className=" w-full  border border-[#0000004D] bg-white rounded-md px-3.5 pb-4 pt-3.5 font-semibold text-4xl text-center">
                      12,000 pts
                    </div>
                  </div>
                  <div className="mt-4 w-full">
                    <Button
                      onClick={() => {
                        navigate("/settings/wallet");
                      }}
                      text="View Points"
                    />
                  </div>
                </div>
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
    </AppLayout>
  );
};
